export const footerLinks = {
  'iq-ar': [
    {
      title: 'أفضل الوجهات',
      items: [
        {
          href: 'https://iq.wingie.com/ar/flights/to-baghdad/',
          title: 'بغداد',
        },
        {
          href: 'https://iq.wingie.com/ar/flights/to-basra/',
          title: 'البصرة',
        },
        {
          href: 'https://iq.wingie.com/ar/flights/to-erbil/',
          title: 'أربيل',
        },
        {
          href: 'https://iq.wingie.com/ar/flights/to-najaf/',
          title: 'النجف',
        },
        {
          href: 'https://iq.wingie.com/ar/flights/to-kuwait/',
          title: 'الكويت',
        },
        {
          href: 'https://iq.wingie.com/ar/flights/to-dubai/',
          title: 'دبي',
        },
      ],
    },
    {
      title: 'الدول الشعبية',
      items: [
        {
          href: 'https://iq.wingie.com/ar/flights/tr-turkey/',
          title: 'تركيا',
        },
        {
          href: 'https://iq.wingie.com/ar/flights/ae-united-arab-emirates/',
          title: 'الإمارات العربية المتحدة',
        },
        {
          href: 'https://iq.wingie.com/ar/flights/kw-kuwait/',
          title: 'الكويت',
        },
        {
          href: 'https://iq.wingie.com/ar/flights/sa-saudi-arabia/',
          title: 'المملكة العربية السعودية',
        },
        {
          href: 'https://iq.wingie.com/ar/flights/ir-iran/',
          title: 'إيران',
        },
        {
          href: 'https://iq.wingie.com/ar/flights/jo-jordan/',
          title: 'الأردن',
        },
      ],
    },
    {
      title: 'شركات الطيران الشعبية',
      items: [
        {
          href: 'https://iq.wingie.com/ar/flights/airlines/iraqi-airways/',
          title: 'الخطوط الجوية العراقية',
        },
        {
          href: 'https://iq.wingie.com/ar/flights/airlines/turkish-airlines/',
          title: 'الخطوط الجوية التركية',
        },
        {
          href: 'https://iq.wingie.com/ar/flights/airlines/emirates/',
          title: 'طيران الإمارات',
        },
        {
          href: 'https://iq.wingie.com/ar/flights/airlines/flydubai/',
          title: 'فلاي دبي',
        },
        {
          href: 'https://iq.wingie.com/ar/flights/airlines/qatar-airways/',
          title: 'الخطوط الجوية القطرية',
        },
        {
          href: 'https://iq.wingie.com/ar/flights/airlines/air-arabia/',
          title: 'العربية للطيران',
        },
      ],
    },
  ],
  'iq-en': [
    {
      title: 'Top Destinations',
      items: [
        {
          href: 'https://iq.wingie.com/en/flights/to-baghdad/',
          title: 'Baghdad',
        },
        {
          href: 'https://iq.wingie.com/en/flights/to-basra/',
          title: 'Basra',
        },
        {
          href: 'https://iq.wingie.com/en/flights/to-erbil/',
          title: 'Erbil',
        },
        {
          href: 'https://iq.wingie.com/en/flights/to-najaf/',
          title: 'Najaf',
        },
        {
          href: 'https://iq.wingie.com/en/flights/to-kuwait/',
          title: 'Kuwait',
        },
        {
          href: 'https://iq.wingie.com/en/flights/to-dubai/',
          title: 'Dubai',
        },
      ],
    },
    {
      title: 'Popular Countries',
      items: [
        {
          href: 'https://iq.wingie.com/en/flights/tr-turkey/',
          title: 'Turkey',
        },
        {
          href: 'https://iq.wingie.com/en/flights/ae-united-arab-emirates/',
          title: 'United Arab Emirates',
        },
        {
          href: 'https://iq.wingie.com/en/flights/kw-kuwait/',
          title: 'Kuwait',
        },
        {
          href: 'https://iq.wingie.com/en/flights/sa-saudi-arabia/',
          title: 'Saudi Arabia',
        },
        {
          href: 'https://iq.wingie.com/en/flights/ir-iran/',
          title: 'Iran',
        },
        {
          href: 'https://iq.wingie.com/en/flights/jo-jordan/',
          title: 'Jordan',
        },
      ],
    },
    {
      title: 'Popular Airlines',
      items: [
        {
          href: 'https://iq.wingie.com/en/flights/airlines/iraqi-airways/',
          title: 'Iraqi Airways',
        },
        {
          href: 'https://iq.wingie.com/en/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://iq.wingie.com/en/flights/airlines/emirates/',
          title: 'Emirates',
        },
        {
          href: 'https://iq.wingie.com/en/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://iq.wingie.com/en/flights/airlines/qatar-airways/',
          title: 'Qatar Airways',
        },
        {
          href: 'https://iq.wingie.com/en/flights/airlines/air-arabia/',
          title: 'Air Arabia',
        },
      ],
    },
  ],
  'iq-ru': [
    {
      title: 'Популярные направления',
      items: [
        {
          href: 'https://iq.wingie.com/ru/flights/to-baghdad/',
          title: 'Багдад',
        },
        {
          href: 'https://iq.wingie.com/ru/flights/to-basra/',
          title: 'Басра',
        },
        {
          href: 'https://iq.wingie.com/ru/flights/to-erbil/',
          title: 'Эрбиль',
        },
        {
          href: 'https://iq.wingie.com/ru/flights/to-najaf/',
          title: 'Наджаф',
        },
        {
          href: 'https://iq.wingie.com/ru/flights/to-kuwait/',
          title: 'Кувейт',
        },
        {
          href: 'https://iq.wingie.com/ru/flights/to-dubai/',
          title: 'Дубай',
        },
      ],
    },
    {
      title: 'Популярные страны',
      items: [
        {
          href: 'https://iq.wingie.com/ru/flights/tr-turkey/',
          title: 'Турция',
        },
        {
          href: 'https://iq.wingie.com/ru/flights/ae-united-arab-emirates/',
          title: 'ОАЭ',
        },
        {
          href: 'https://iq.wingie.com/ru/flights/kw-kuwait/',
          title: 'Кувейт',
        },
        {
          href: 'https://iq.wingie.com/ru/flights/sa-saudi-arabia/',
          title: 'Саудовская Аравия',
        },
        {
          href: 'https://iq.wingie.com/ru/flights/ir-iran/',
          title: 'Иран',
        },
        {
          href: 'https://iq.wingie.com/ru/flights/jo-jordan/',
          title: 'Иордания',
        },
      ],
    },
    {
      title: 'Популярные авиакомпании',
      items: [
        {
          href: 'https://iq.wingie.com/ru/flights/airlines/iraqi-airways/',
          title: 'Iraqi Airways',
        },
        {
          href: 'https://iq.wingie.com/ru/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://iq.wingie.com/ru/flights/airlines/emirates/',
          title: 'Emirates',
        },
        {
          href: 'https://iq.wingie.com/ru/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://iq.wingie.com/ru/flights/airlines/qatar-airways/',
          title: 'Qatar Airways',
        },
        {
          href: 'https://iq.wingie.com/ru/flights/airlines/air-arabia/',
          title: 'Air Arabia',
        },
      ],
    },
  ],
  'iq-de': [
    {
      title: 'Top-Destinationen',
      items: [
        {
          href: 'https://iq.wingie.com/de/fluge/nach-bagdad/',
          title: 'Bagdad',
        },
        {
          href: 'https://iq.wingie.com/de/fluge/nach-basra/',
          title: 'Basra',
        },
        {
          href: 'https://iq.wingie.com/de/fluge/nach-erbil/',
          title: 'Erbil',
        },
        {
          href: 'https://iq.wingie.com/de/fluge/nach-nadschaf/',
          title: 'Nadschaf',
        },
        {
          href: 'https://iq.wingie.com/de/fluge/nach-kuwait/',
          title: 'Kuwait',
        },
        {
          href: 'https://iq.wingie.com/de/fluge/nach-dubai/',
          title: 'Dubai',
        },
      ],
    },
    {
      title: 'Beliebte Länder',
      items: [
        {
          href: 'https://iq.wingie.com/de/fluge/tr-turkei/',
          title: 'Türkei',
        },
        {
          href: 'https://iq.wingie.com/de/fluge/ae-vereinigte-arabische-emirate/',
          title: 'Vereinigte Arabische Emirate',
        },
        {
          href: 'https://iq.wingie.com/de/fluge/kw-kuwait/',
          title: 'Kuwait',
        },
        {
          href: 'https://iq.wingie.com/de/fluge/sa-saudi-arabien/',
          title: 'Saudi-Arabien',
        },
        {
          href: 'https://iq.wingie.com/de/fluge/ir-iran/',
          title: 'Iran',
        },
        {
          href: 'https://iq.wingie.com/de/fluge/jo-jordanien/',
          title: 'Jordanien',
        },
      ],
    },
    {
      title: 'Beliebte Fluggesellschaften',
      items: [
        {
          href: 'https://iq.wingie.com/de/fluge/fluggesellschaften/iraqi-airways/',
          title: 'Iraqi Airways',
        },
        {
          href: 'https://iq.wingie.com/de/fluge/fluggesellschaften/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://iq.wingie.com/de/fluge/fluggesellschaften/emirates/',
          title: 'Emirates',
        },
        {
          href: 'https://iq.wingie.com/de/fluge/fluggesellschaften/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://iq.wingie.com/de/fluge/fluggesellschaften/qatar-airways/',
          title: 'Qatar Airways',
        },
        {
          href: 'https://iq.wingie.com/de/fluge/fluggesellschaften/air-arabia/',
          title: 'Air Arabia',
        },
      ],
    },
  ],
  'iq-es': [
    {
      title: 'Destinos principales',
      items: [
        {
          href: 'https://iq.wingie.com/es/vuelos/a-bagdad/',
          title: 'Bagdad',
        },
        {
          href: 'https://iq.wingie.com/es/vuelos/a-basora/',
          title: 'Basora',
        },
        {
          href: 'https://iq.wingie.com/es/vuelos/a-erbil/',
          title: 'Erbil',
        },
        {
          href: 'https://iq.wingie.com/es/vuelos/a-najaf/',
          title: 'Najaf',
        },
        {
          href: 'https://iq.wingie.com/es/vuelos/a-kuwait/',
          title: 'Kuwait',
        },
        {
          href: 'https://iq.wingie.com/es/vuelos/a-dubai/',
          title: 'Dubái',
        },
      ],
    },
    {
      title: 'Países populares',
      items: [
        {
          href: 'https://iq.wingie.com/es/vuelos/tr-turquia/',
          title: 'Turquía',
        },
        {
          href: 'https://iq.wingie.com/es/vuelos/ae-emiratos-arabes-unidos/',
          title: 'Emiratos Árabes Unidos',
        },
        {
          href: 'https://iq.wingie.com/es/vuelos/kw-kuwait/',
          title: 'Kuwait',
        },
        {
          href: 'https://iq.wingie.com/es/vuelos/sa-arabia-saudi/',
          title: 'Arabia Saudí',
        },
        {
          href: 'https://iq.wingie.com/es/vuelos/ir-iran/',
          title: 'Irán',
        },
        {
          href: 'https://iq.wingie.com/es/vuelos/jo-jordania/',
          title: 'Jordania',
        },
      ],
    },
    {
      title: 'Aerolíneas populares',
      items: [
        {
          href: 'https://iq.wingie.com/es/vuelos/aerolineas/iraqi-airways/',
          title: 'Iraqi Airways',
        },
        {
          href: 'https://iq.wingie.com/es/vuelos/aerolineas/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://iq.wingie.com/es/vuelos/aerolineas/emirates/',
          title: 'Emirates',
        },
        {
          href: 'https://iq.wingie.com/es/vuelos/aerolineas/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://iq.wingie.com/es/vuelos/aerolineas/qatar-airways/',
          title: 'Qatar Airways',
        },
        {
          href: 'https://iq.wingie.com/es/vuelos/aerolineas/air-arabia/',
          title: 'Air Arabia',
        },
      ],
    },
  ],
  'iq-it': [
    {
      title: 'Destinazioni principali',
      items: [
        {
          href: 'https://iq.wingie.com/it/flights/to-baghdad/',
          title: 'Baghdad',
        },
        {
          href: 'https://iq.wingie.com/it/flights/to-basra/',
          title: 'Basra',
        },
        {
          href: 'https://iq.wingie.com/it/flights/to-erbil/',
          title: 'Erbil',
        },
        {
          href: 'https://iq.wingie.com/it/flights/to-najaf/',
          title: 'Najaf',
        },
        {
          href: 'https://iq.wingie.com/it/flights/to-kuwait/',
          title: 'Kuwait',
        },
        {
          href: 'https://iq.wingie.com/it/flights/to-dubai/',
          title: 'Dubai',
        },
      ],
    },
    {
      title: 'Paesi popolari',
      items: [
        {
          href: 'https://iq.wingie.com/it/flights/tr-turkey/',
          title: 'Turchia',
        },
        {
          href: 'https://iq.wingie.com/it/flights/ae-united-arab-emirates/',
          title: 'Emirati Arabi Uniti',
        },
        {
          href: 'https://iq.wingie.com/it/flights/kw-kuwait/',
          title: 'Kuwait',
        },
        {
          href: 'https://iq.wingie.com/it/flights/sa-saudi-arabia/',
          title: 'Arabia Saudita',
        },
        {
          href: 'https://iq.wingie.com/it/flights/ir-iran/',
          title: 'Iran',
        },
        {
          href: 'https://iq.wingie.com/it/flights/jo-jordan/',
          title: 'Giordania',
        },
      ],
    },
    {
      title: 'Compagnie aeree popolari',
      items: [
        {
          href: 'https://iq.wingie.com/it/flights/airlines/iraqi-airways/',
          title: 'Iraqi Airways',
        },
        {
          href: 'https://iq.wingie.com/it/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://iq.wingie.com/it/flights/airlines/emirates/',
          title: 'Emirates',
        },
        {
          href: 'https://iq.wingie.com/it/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://iq.wingie.com/it/flights/airlines/qatar-airways/',
          title: 'Qatar Airways',
        },
        {
          href: 'https://iq.wingie.com/it/flights/airlines/air-arabia/',
          title: 'Air Arabia',
        },
      ],
    },
  ],
  'iq-fr': [
    {
      title: 'Destinations principales',
      items: [
        {
          href: 'https://iq.wingie.com/fr/flights/to-baghdad/',
          title: 'Bagdad',
        },
        {
          href: 'https://iq.wingie.com/fr/flights/to-basra/',
          title: 'Bassora',
        },
        {
          href: 'https://iq.wingie.com/fr/flights/to-erbil/',
          title: 'Erbil',
        },
        {
          href: 'https://iq.wingie.com/fr/flights/to-najaf/',
          title: 'Najaf',
        },
        {
          href: 'https://iq.wingie.com/fr/flights/to-kuwait/',
          title: 'Koweït',
        },
        {
          href: 'https://iq.wingie.com/fr/flights/to-dubai/',
          title: 'Dubaï',
        },
      ],
    },
    {
      title: 'Pays populaires',
      items: [
        {
          href: 'https://iq.wingie.com/fr/flights/tr-turkey/',
          title: 'Turquie',
        },
        {
          href: 'https://iq.wingie.com/fr/flights/ae-united-arab-emirates/',
          title: 'Émirats arabes unis',
        },
        {
          href: 'https://iq.wingie.com/fr/flights/kw-kuwait/',
          title: 'Koweït',
        },
        {
          href: 'https://iq.wingie.com/fr/flights/sa-saudi-arabia/',
          title: 'Arabie saoudite',
        },
        {
          href: 'https://iq.wingie.com/fr/flights/ir-iran/',
          title: 'Iran',
        },
        {
          href: 'https://iq.wingie.com/fr/flights/jo-jordan/',
          title: 'Jordanie',
        },
      ],
    },
    {
      title: 'Compagnies aériennes populaires',
      items: [
        {
          href: 'https://iq.wingie.com/fr/flights/airlines/iraqi-airways/',
          title: 'Iraqi Airways',
        },
        {
          href: 'https://iq.wingie.com/fr/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://iq.wingie.com/fr/flights/airlines/emirates/',
          title: 'Emirates',
        },
        {
          href: 'https://iq.wingie.com/fr/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://iq.wingie.com/fr/flights/airlines/qatar-airways/',
          title: 'Qatar Airways',
        },
        {
          href: 'https://iq.wingie.com/fr/flights/airlines/air-arabia/',
          title: 'Air Arabia',
        },
      ],
    },
  ],
  'iq-pt': [
    {
      title: 'Destinos principais',
      items: [
        {
          href: 'https://iq.wingie.com/pt/flights/to-baghdad/',
          title: 'Bagdá',
        },
        {
          href: 'https://iq.wingie.com/pt/flights/to-basra/',
          title: 'Basra',
        },
        {
          href: 'https://iq.wingie.com/pt/flights/to-erbil/',
          title: 'Erbil',
        },
        {
          href: 'https://iq.wingie.com/pt/flights/to-najaf/',
          title: 'Najaf',
        },
        {
          href: 'https://iq.wingie.com/pt/flights/to-kuwait/',
          title: 'Kuwait',
        },
        {
          href: 'https://iq.wingie.com/pt/flights/to-dubai/',
          title: 'Dubai',
        },
      ],
    },
    {
      title: 'Países populares',
      items: [
        {
          href: 'https://iq.wingie.com/pt/flights/tr-turkey/',
          title: 'Turquia',
        },
        {
          href: 'https://iq.wingie.com/pt/flights/ae-united-arab-emirates/',
          title: 'Emirados Árabes Unidos',
        },
        {
          href: 'https://iq.wingie.com/pt/flights/kw-kuwait/',
          title: 'Kuwait',
        },
        {
          href: 'https://iq.wingie.com/pt/flights/sa-saudi-arabia/',
          title: 'Arábia Saudita',
        },
        {
          href: 'https://iq.wingie.com/pt/flights/ir-iran/',
          title: 'Irã',
        },
        {
          href: 'https://iq.wingie.com/pt/flights/jo-jordan/',
          title: 'Jordânia',
        },
      ],
    },
    {
      title: 'Companhias aéreas populares',
      items: [
        {
          href: 'https://iq.wingie.com/pt/flights/airlines/iraqi-airways/',
          title: 'Iraqi Airways',
        },
        {
          href: 'https://iq.wingie.com/pt/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://iq.wingie.com/pt/flights/airlines/emirates/',
          title: 'Emirates',
        },
        {
          href: 'https://iq.wingie.com/pt/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://iq.wingie.com/pt/flights/airlines/qatar-airways/',
          title: 'Qatar Airways',
        },
        {
          href: 'https://iq.wingie.com/pt/flights/airlines/air-arabia/',
          title: 'Air Arabia',
        },
      ],
    },
  ],
  'iq-ro': [
    {
      title: 'Destinații principale',
      items: [
        {
          href: 'https://iq.wingie.com/ro/flights/to-baghdad/',
          title: 'Bagdad',
        },
        {
          href: 'https://iq.wingie.com/ro/flights/to-basra/',
          title: 'Basra',
        },
        {
          href: 'https://iq.wingie.com/ro/flights/to-erbil/',
          title: 'Erbil',
        },
        {
          href: 'https://iq.wingie.com/ro/flights/to-najaf/',
          title: 'Najaf',
        },
        {
          href: 'https://iq.wingie.com/ro/flights/to-kuwait/',
          title: 'Kuwait',
        },
        {
          href: 'https://iq.wingie.com/ro/flights/to-dubai/',
          title: 'Dubai',
        },
      ],
    },
    {
      title: 'Țări populare',
      items: [
        {
          href: 'https://iq.wingie.com/ro/flights/tr-turkey/',
          title: 'Turcia',
        },
        {
          href: 'https://iq.wingie.com/ro/flights/ae-united-arab-emirates/',
          title: 'Emiratele Arabe Unite',
        },
        {
          href: 'https://iq.wingie.com/ro/flights/kw-kuwait/',
          title: 'Kuwait',
        },
        {
          href: 'https://iq.wingie.com/ro/flights/sa-saudi-arabia/',
          title: 'Arabia Saudită',
        },
        {
          href: 'https://iq.wingie.com/ro/flights/ir-iran/',
          title: 'Iran',
        },
        {
          href: 'https://iq.wingie.com/ro/flights/jo-jordan/',
          title: 'Iordania',
        },
      ],
    },
    {
      title: 'Companii aeriene populare',
      items: [
        {
          href: 'https://iq.wingie.com/ro/flights/airlines/iraqi-airways/',
          title: 'Iraqi Airways',
        },
        {
          href: 'https://iq.wingie.com/ro/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://iq.wingie.com/ro/flights/airlines/emirates/',
          title: 'Emirates',
        },
        {
          href: 'https://iq.wingie.com/ro/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://iq.wingie.com/ro/flights/airlines/qatar-airways/',
          title: 'Qatar Airways',
        },
        {
          href: 'https://iq.wingie.com/ro/flights/airlines/air-arabia/',
          title: 'Air Arabia',
        },
      ],
    },
  ],
  'iq-pl': [
    {
      title: 'Popularne kierunki',
      items: [
        {
          href: 'https://iq.wingie.com/pl/flights/to-baghdad/',
          title: 'Bagdad',
        },
        {
          href: 'https://iq.wingie.com/pl/flights/to-basra/',
          title: 'Basra',
        },
        {
          href: 'https://iq.wingie.com/pl/flights/to-erbil/',
          title: 'Erbil',
        },
        {
          href: 'https://iq.wingie.com/pl/flights/to-najaf/',
          title: 'Najaf',
        },
        {
          href: 'https://iq.wingie.com/pl/flights/to-kuwait/',
          title: 'Kuwejt',
        },
        {
          href: 'https://iq.wingie.com/pl/flights/to-dubai/',
          title: 'Dubaj',
        },
      ],
    },
    {
      title: 'Popularne kraje',
      items: [
        {
          href: 'https://iq.wingie.com/pl/flights/tr-turkey/',
          title: 'Turcja',
        },
        {
          href: 'https://iq.wingie.com/pl/flights/ae-united-arab-emirates/',
          title: 'Zjednoczone Emiraty Arabskie',
        },
        {
          href: 'https://iq.wingie.com/pl/flights/kw-kuwait/',
          title: 'Kuwejt',
        },
        {
          href: 'https://iq.wingie.com/pl/flights/sa-saudi-arabia/',
          title: 'Arabia Saudyjska',
        },
        {
          href: 'https://iq.wingie.com/pl/flights/ir-iran/',
          title: 'Iran',
        },
        {
          href: 'https://iq.wingie.com/pl/flights/jo-jordan/',
          title: 'Jordania',
        },
      ],
    },
    {
      title: 'Popularne linie lotnicze',
      items: [
        {
          href: 'https://iq.wingie.com/pl/flights/airlines/iraqi-airways/',
          title: 'Iraqi Airways',
        },
        {
          href: 'https://iq.wingie.com/pl/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://iq.wingie.com/pl/flights/airlines/emirates/',
          title: 'Emirates',
        },
        {
          href: 'https://iq.wingie.com/pl/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://iq.wingie.com/pl/flights/airlines/qatar-airways/',
          title: 'Qatar Airways',
        },
        {
          href: 'https://iq.wingie.com/pl/flights/airlines/air-arabia/',
          title: 'Air Arabia',
        },
      ],
    },
  ],
  'iq-lt': [
    {
      title: 'Populiarūs kryptys',
      items: [
        {
          href: 'https://iq.wingie.com/lt/flights/to-baghdad/',
          title: 'Bagdadas',
        },
        {
          href: 'https://iq.wingie.com/lt/flights/to-basra/',
          title: 'Basra',
        },
        {
          href: 'https://iq.wingie.com/lt/flights/to-erbil/',
          title: 'Erbilis',
        },
        {
          href: 'https://iq.wingie.com/lt/flights/to-najaf/',
          title: 'Najafas',
        },
        {
          href: 'https://iq.wingie.com/lt/flights/to-kuwait/',
          title: 'Kuveitas',
        },
        {
          href: 'https://iq.wingie.com/lt/flights/to-dubai/',
          title: 'Dubajus',
        },
      ],
    },
    {
      title: 'Populiarios šalys',
      items: [
        {
          href: 'https://iq.wingie.com/lt/flights/tr-turkey/',
          title: 'Turkija',
        },
        {
          href: 'https://iq.wingie.com/lt/flights/ae-united-arab-emirates/',
          title: 'Jungtiniai Arabų Emyratai',
        },
        {
          href: 'https://iq.wingie.com/lt/flights/kw-kuwait/',
          title: 'Kuveitas',
        },
        {
          href: 'https://iq.wingie.com/lt/flights/sa-saudi-arabia/',
          title: 'Saudo Arabija',
        },
        {
          href: 'https://iq.wingie.com/lt/flights/ir-iran/',
          title: 'Iranas',
        },
        {
          href: 'https://iq.wingie.com/lt/flights/jo-jordan/',
          title: 'Jordanija',
        },
      ],
    },
    {
      title: 'Populiarūs oro vežėjai',
      items: [
        {
          href: 'https://iq.wingie.com/lt/flights/airlines/iraqi-airways/',
          title: 'Iraqi Airways',
        },
        {
          href: 'https://iq.wingie.com/lt/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://iq.wingie.com/lt/flights/airlines/emirates/',
          title: 'Emirates',
        },
        {
          href: 'https://iq.wingie.com/lt/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://iq.wingie.com/lt/flights/airlines/qatar-airways/',
          title: 'Qatar Airways',
        },
        {
          href: 'https://iq.wingie.com/lt/flights/airlines/air-arabia/',
          title: 'Air Arabia',
        },
      ],
    },
  ],
  'iq-uz': [
    {
      title: "Mashhur yo'nalishlar",
      items: [
        {
          href: 'https://iq.wingie.com/uz/flights/to-baghdad/',
          title: 'Bagdod',
        },
        {
          href: 'https://iq.wingie.com/uz/flights/to-basra/',
          title: 'Basra',
        },
        {
          href: 'https://iq.wingie.com/uz/flights/to-erbil/',
          title: 'Erbil',
        },
        {
          href: 'https://iq.wingie.com/uz/flights/to-najaf/',
          title: 'Najaf',
        },
        {
          href: 'https://iq.wingie.com/uz/flights/to-kuwait/',
          title: 'Kuvayt',
        },
        {
          href: 'https://iq.wingie.com/uz/flights/to-dubai/',
          title: 'Dubay',
        },
      ],
    },
    {
      title: 'Mashhur mamlakatlar',
      items: [
        {
          href: 'https://iq.wingie.com/uz/flights/tr-turkey/',
          title: 'Turkiya',
        },
        {
          href: 'https://iq.wingie.com/uz/flights/ae-united-arab-emirates/',
          title: 'Birlashgan Arab Amirliklari',
        },
        {
          href: 'https://iq.wingie.com/uz/flights/kw-kuwait/',
          title: 'Kuvayt',
        },
        {
          href: 'https://iq.wingie.com/uz/flights/sa-saudi-arabia/',
          title: 'Saudiya Arabistoni',
        },
        {
          href: 'https://iq.wingie.com/uz/flights/ir-iran/',
          title: 'Eron',
        },
        {
          href: 'https://iq.wingie.com/uz/flights/jo-jordan/',
          title: 'Iordaniya',
        },
      ],
    },
    {
      title: 'Mashhur aviakompaniyalar',
      items: [
        {
          href: 'https://iq.wingie.com/uz/flights/airlines/iraqi-airways/',
          title: 'Iraqi Airways',
        },
        {
          href: 'https://iq.wingie.com/uz/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://iq.wingie.com/uz/flights/airlines/emirates/',
          title: 'Emirates',
        },
        {
          href: 'https://iq.wingie.com/uz/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://iq.wingie.com/uz/flights/airlines/qatar-airways/',
          title: 'Qatar Airways',
        },
        {
          href: 'https://iq.wingie.com/uz/flights/airlines/air-arabia/',
          title: 'Air Arabia',
        },
      ],
    },
  ],
  'iq-sr': [
    {
      title: 'Популарне дестинације',
      items: [
        {
          href: 'https://iq.wingie.com/sr/flights/to-baghdad/',
          title: 'Багдад',
        },
        {
          href: 'https://iq.wingie.com/sr/flights/to-basra/',
          title: 'Басра',
        },
        {
          href: 'https://iq.wingie.com/sr/flights/to-erbil/',
          title: 'Ербил',
        },
        {
          href: 'https://iq.wingie.com/sr/flights/to-najaf/',
          title: 'Најаф',
        },
        {
          href: 'https://iq.wingie.com/sr/flights/to-kuwait/',
          title: 'Кувајт',
        },
        {
          href: 'https://iq.wingie.com/sr/flights/to-dubai/',
          title: 'Дубаи',
        },
      ],
    },
    {
      title: 'Популарне земље',
      items: [
        {
          href: 'https://iq.wingie.com/sr/flights/tr-turkey/',
          title: 'Турска',
        },
        {
          href: 'https://iq.wingie.com/sr/flights/ae-united-arab-emirates/',
          title: 'Уједињени Арапски Емирати',
        },
        {
          href: 'https://iq.wingie.com/sr/flights/kw-kuwait/',
          title: 'Кувајт',
        },
        {
          href: 'https://iq.wingie.com/sr/flights/sa-saudi-arabia/',
          title: 'Саудијска Арабија',
        },
        {
          href: 'https://iq.wingie.com/sr/flights/ir-iran/',
          title: 'Иран',
        },
        {
          href: 'https://iq.wingie.com/sr/flights/jo-jordan/',
          title: 'Јордан',
        },
      ],
    },
    {
      title: 'Популарне авио-компаније',
      items: [
        {
          href: 'https://iq.wingie.com/sr/flights/airlines/iraqi-airways/',
          title: 'Iraqi Airways',
        },
        {
          href: 'https://iq.wingie.com/sr/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://iq.wingie.com/sr/flights/airlines/emirates/',
          title: 'Emirates',
        },
        {
          href: 'https://iq.wingie.com/sr/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://iq.wingie.com/sr/flights/airlines/qatar-airways/',
          title: 'Qatar Airways',
        },
        {
          href: 'https://iq.wingie.com/sr/flights/airlines/air-arabia/',
          title: 'Air Arabia',
        },
      ],
    },
  ],
  'iq-ky': [
    {
      title: 'Популярдуу багыттар',
      items: [
        {
          href: 'https://iq.wingie.com/ky/flights/to-baghdad/',
          title: 'Багдад',
        },
        {
          href: 'https://iq.wingie.com/ky/flights/to-basra/',
          title: 'Басра',
        },
        {
          href: 'https://iq.wingie.com/ky/flights/to-erbil/',
          title: 'Эрбил',
        },
        {
          href: 'https://iq.wingie.com/ky/flights/to-najaf/',
          title: 'Нажаф',
        },
        {
          href: 'https://iq.wingie.com/ky/flights/to-kuwait/',
          title: 'Кувейт',
        },
        {
          href: 'https://iq.wingie.com/ky/flights/to-dubai/',
          title: 'Дубай',
        },
      ],
    },
    {
      title: 'Популярдуу өлкөлөр',
      items: [
        {
          href: 'https://iq.wingie.com/ky/flights/tr-turkey/',
          title: 'Түркия',
        },
        {
          href: 'https://iq.wingie.com/ky/flights/ae-united-arab-emirates/',
          title: 'Бириккен Араб Эмиратары',
        },
        {
          href: 'https://iq.wingie.com/ky/flights/kw-kuwait/',
          title: 'Кувейт',
        },
        {
          href: 'https://iq.wingie.com/ky/flights/sa-saudi-arabia/',
          title: 'Сауд Арабиясы',
        },
        {
          href: 'https://iq.wingie.com/ky/flights/ir-iran/',
          title: 'Иран',
        },
        {
          href: 'https://iq.wingie.com/ky/flights/jo-jordan/',
          title: 'Иордания',
        },
      ],
    },
    {
      title: 'Популярдуу авиакомпаниялар',
      items: [
        {
          href: 'https://iq.wingie.com/ky/flights/airlines/iraqi-airways/',
          title: 'Iraqi Airways',
        },
        {
          href: 'https://iq.wingie.com/ky/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://iq.wingie.com/ky/flights/airlines/emirates/',
          title: 'Emirates',
        },
        {
          href: 'https://iq.wingie.com/ky/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://iq.wingie.com/ky/flights/airlines/qatar-airways/',
          title: 'Qatar Airways',
        },
        {
          href: 'https://iq.wingie.com/ky/flights/airlines/air-arabia/',
          title: 'Air Arabia',
        },
      ],
    },
  ],
  'iq-tg': [
    {
      title: 'Самтҳои маъмул',
      items: [
        {
          href: 'https://iq.wingie.com/tg/flights/to-baghdad/',
          title: 'Бағдод',
        },
        {
          href: 'https://iq.wingie.com/tg/flights/to-basra/',
          title: 'Басра',
        },
        {
          href: 'https://iq.wingie.com/tg/flights/to-erbil/',
          title: 'Арбил',
        },
        {
          href: 'https://iq.wingie.com/tg/flights/to-najaf/',
          title: 'Наҷаф',
        },
        {
          href: 'https://iq.wingie.com/tg/flights/to-kuwait/',
          title: 'Кувайт',
        },
        {
          href: 'https://iq.wingie.com/tg/flights/to-dubai/',
          title: 'Дубай',
        },
      ],
    },
    {
      title: 'Кишварҳои маъмул',
      items: [
        {
          href: 'https://iq.wingie.com/tg/flights/tr-turkey/',
          title: 'Туркия',
        },
        {
          href: 'https://iq.wingie.com/tg/flights/ae-united-arab-emirates/',
          title: 'Аморати Муттаҳидаи Араб',
        },
        {
          href: 'https://iq.wingie.com/tg/flights/kw-kuwait/',
          title: 'Кувайт',
        },
        {
          href: 'https://iq.wingie.com/tg/flights/sa-saudi-arabia/',
          title: 'Арабистони Саудӣ',
        },
        {
          href: 'https://iq.wingie.com/tg/flights/ir-iran/',
          title: 'Эрон',
        },
        {
          href: 'https://iq.wingie.com/tg/flights/jo-jordan/',
          title: 'Урдун',
        },
      ],
    },
    {
      title: 'Ширкатҳои маъмули ҳавопаймоӣ',
      items: [
        {
          href: 'https://iq.wingie.com/tg/flights/airlines/iraqi-airways/',
          title: 'Iraqi Airways',
        },
        {
          href: 'https://iq.wingie.com/tg/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://iq.wingie.com/tg/flights/airlines/emirates/',
          title: 'Emirates',
        },
        {
          href: 'https://iq.wingie.com/tg/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://iq.wingie.com/tg/flights/airlines/qatar-airways/',
          title: 'Qatar Airways',
        },
        {
          href: 'https://iq.wingie.com/tg/flights/airlines/air-arabia/',
          title: 'Air Arabia',
        },
      ],
    },
  ],
  'iq-kk': [
    {
      title: 'Танымал бағыттар',
      items: [
        {
          href: 'https://iq.wingie.com/kk/flights/to-baghdad/',
          title: 'Бағдад',
        },
        {
          href: 'https://iq.wingie.com/kk/flights/to-basra/',
          title: 'Басра',
        },
        {
          href: 'https://iq.wingie.com/kk/flights/to-erbil/',
          title: 'Эрбил',
        },
        {
          href: 'https://iq.wingie.com/kk/flights/to-najaf/',
          title: 'Нажаф',
        },
        {
          href: 'https://iq.wingie.com/kk/flights/to-kuwait/',
          title: 'Кувейт',
        },
        {
          href: 'https://iq.wingie.com/kk/flights/to-dubai/',
          title: 'Дубай',
        },
      ],
    },
    {
      title: 'Танымал елдер',
      items: [
        {
          href: 'https://iq.wingie.com/kk/flights/tr-turkey/',
          title: 'Түркия',
        },
        {
          href: 'https://iq.wingie.com/kk/flights/ae-united-arab-emirates/',
          title: 'Біріккен Араб Әмірліктері',
        },
        {
          href: 'https://iq.wingie.com/kk/flights/kw-kuwait/',
          title: 'Кувейт',
        },
        {
          href: 'https://iq.wingie.com/kk/flights/sa-saudi-arabia/',
          title: 'Сауд Арабиясы',
        },
        {
          href: 'https://iq.wingie.com/kk/flights/ir-iran/',
          title: 'Иран',
        },
        {
          href: 'https://iq.wingie.com/kk/flights/jo-jordan/',
          title: 'Иордания',
        },
      ],
    },
    {
      title: 'Танымал авиакомпаниялар',
      items: [
        {
          href: 'https://iq.wingie.com/kk/flights/airlines/iraqi-airways/',
          title: 'Iraqi Airways',
        },
        {
          href: 'https://iq.wingie.com/kk/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://iq.wingie.com/kk/flights/airlines/emirates/',
          title: 'Emirates',
        },
        {
          href: 'https://iq.wingie.com/kk/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://iq.wingie.com/kk/flights/airlines/qatar-airways/',
          title: 'Qatar Airways',
        },
        {
          href: 'https://iq.wingie.com/kk/flights/airlines/air-arabia/',
          title: 'Air Arabia',
        },
      ],
    },
  ],
  'iq-nl': [
    {
      title: 'Populaire bestemmingen',
      items: [
        {
          href: 'https://iq.wingie.com/nl/flights/to-baghdad/',
          title: 'Bagdad',
        },
        {
          href: 'https://iq.wingie.com/nl/flights/to-basra/',
          title: 'Basra',
        },
        {
          href: 'https://iq.wingie.com/nl/flights/to-erbil/',
          title: 'Erbil',
        },
        {
          href: 'https://iq.wingie.com/nl/flights/to-najaf/',
          title: 'Najaf',
        },
        {
          href: 'https://iq.wingie.com/nl/flights/to-kuwait/',
          title: 'Koeweit',
        },
        {
          href: 'https://iq.wingie.com/nl/flights/to-dubai/',
          title: 'Dubai',
        },
      ],
    },
    {
      title: 'Populaire landen',
      items: [
        {
          href: 'https://iq.wingie.com/nl/flights/tr-turkey/',
          title: 'Turkije',
        },
        {
          href: 'https://iq.wingie.com/nl/flights/ae-united-arab-emirates/',
          title: 'Verenigde Arabische Emiraten',
        },
        {
          href: 'https://iq.wingie.com/nl/flights/kw-kuwait/',
          title: 'Koeweit',
        },
        {
          href: 'https://iq.wingie.com/nl/flights/sa-saudi-arabia/',
          title: 'Saoedi-Arabië',
        },
        {
          href: 'https://iq.wingie.com/nl/flights/ir-iran/',
          title: 'Iran',
        },
        {
          href: 'https://iq.wingie.com/nl/flights/jo-jordan/',
          title: 'Jordanië',
        },
      ],
    },
    {
      title: 'Populaire luchtvaartmaatschappijen',
      items: [
        {
          href: 'https://iq.wingie.com/nl/flights/airlines/iraqi-airways/',
          title: 'Iraqi Airways',
        },
        {
          href: 'https://iq.wingie.com/nl/flights/airlines/turkish-airlines/',
          title: 'Turkish Airlines',
        },
        {
          href: 'https://iq.wingie.com/nl/flights/airlines/emirates/',
          title: 'Emirates',
        },
        {
          href: 'https://iq.wingie.com/nl/flights/airlines/flydubai/',
          title: 'flydubai',
        },
        {
          href: 'https://iq.wingie.com/nl/flights/airlines/qatar-airways/',
          title: 'Qatar Airways',
        },
        {
          href: 'https://iq.wingie.com/nl/flights/airlines/air-arabia/',
          title: 'Air Arabia',
        },
      ],
    },
  ],
    'iq-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://iq.wingie.com/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://iq.wingie.com/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://iq.wingie.com/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://iq.wingie.com/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://iq.wingie.com/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://iq.wingie.com/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://iq.wingie.com/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://iq.wingie.com/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://iq.wingie.com/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://iq.wingie.com/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://iq.wingie.com/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://iq.wingie.com/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://iq.wingie.com/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://iq.wingie.com/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://iq.wingie.com/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://iq.wingie.com/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://iq.wingie.com/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://iq.wingie.com/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'iq-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://iq.wingie.com/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://iq.wingie.com/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://iq.wingie.com/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://iq.wingie.com/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://iq.wingie.com/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://iq.wingie.com/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://iq.wingie.com/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://iq.wingie.com/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://iq.wingie.com/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://iq.wingie.com/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://iq.wingie.com/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://iq.wingie.com/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://iq.wingie.com/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://iq.wingie.com/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://iq.wingie.com/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://iq.wingie.com/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://iq.wingie.com/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://iq.wingie.com/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'iq-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://iq.wingie.com/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://iq.wingie.com/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://iq.wingie.com/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://iq.wingie.com/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://iq.wingie.com/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://iq.wingie.com/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://iq.wingie.com/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://iq.wingie.com/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://iq.wingie.com/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://iq.wingie.com/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://iq.wingie.com/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://iq.wingie.com/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://iq.wingie.com/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://iq.wingie.com/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://iq.wingie.com/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://iq.wingie.com/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://iq.wingie.com/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://iq.wingie.com/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'iq-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://iq.wingie.com/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://iq.wingie.com/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://iq.wingie.com/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://iq.wingie.com/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://iq.wingie.com/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://iq.wingie.com/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://iq.wingie.com/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://iq.wingie.com/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://iq.wingie.com/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://iq.wingie.com/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://iq.wingie.com/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://iq.wingie.com/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://iq.wingie.com/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://iq.wingie.com/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://iq.wingie.com/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://iq.wingie.com/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://iq.wingie.com/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://iq.wingie.com/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'iq-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://iq.wingie.com/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://iq.wingie.com/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://iq.wingie.com/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://iq.wingie.com/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://iq.wingie.com/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://iq.wingie.com/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://iq.wingie.com/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://iq.wingie.com/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://iq.wingie.com/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://iq.wingie.com/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://iq.wingie.com/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://iq.wingie.com/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://iq.wingie.com/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://iq.wingie.com/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://iq.wingie.com/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://iq.wingie.com/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://iq.wingie.com/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://iq.wingie.com/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'iq-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://iq.wingie.com/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://iq.wingie.com/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://iq.wingie.com/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://iq.wingie.com/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://iq.wingie.com/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://iq.wingie.com/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://iq.wingie.com/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://iq.wingie.com/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://iq.wingie.com/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://iq.wingie.com/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://iq.wingie.com/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://iq.wingie.com/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://iq.wingie.com/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://iq.wingie.com/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://iq.wingie.com/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://iq.wingie.com/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://iq.wingie.com/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://iq.wingie.com/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'iq-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://iq.wingie.com/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://iq.wingie.com/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://iq.wingie.com/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://iq.wingie.com/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://iq.wingie.com/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://iq.wingie.com/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://iq.wingie.com/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://iq.wingie.com/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://iq.wingie.com/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://iq.wingie.com/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://iq.wingie.com/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://iq.wingie.com/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://iq.wingie.com/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://iq.wingie.com/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://iq.wingie.com/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://iq.wingie.com/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://iq.wingie.com/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://iq.wingie.com/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'iq-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://iq.wingie.com/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://iq.wingie.com/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://iq.wingie.com/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://iq.wingie.com/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://iq.wingie.com/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://iq.wingie.com/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://iq.wingie.com/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://iq.wingie.com/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://iq.wingie.com/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://iq.wingie.com/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://iq.wingie.com/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://iq.wingie.com/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://iq.wingie.com/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://iq.wingie.com/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://iq.wingie.com/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://iq.wingie.com/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://iq.wingie.com/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://iq.wingie.com/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ]
}